<main class="govuk-width-container" *ngIf="showContent" id="main-content" tabindex="-1">
	<div class="govuk-grid-row">
		<div class="govuk-grid-column-full">
			<h2 class="mb-3">
				{{ startPageSubtitle }}
			</h2>

			<div [innerHTML]="startPageSubtitleBody"></div>

			<div class="button-container">
				<button class="btn btn-primary" (click)="startBooking()">
					Book your ceremony
				</button>
			</div>
		</div>
	</div>
</main>
